import { useState } from "react";
import Establishment from "../../models/establishment";
import { CCard, CCardBody, CCardHeader, CCollapse } from "@coreui/react";

import EstablishmentCrudActions from "./EstablishmentCrudActions";

interface EstablishmentCardProps {
  establishment: Establishment;
  onUpdateClick: (inv: Establishment) => void;
  onDeleteClick: (inv: Establishment) => void;
  isDemo?: boolean;
}

export function EstablishmentCard({
  establishment,
  onUpdateClick,
  onDeleteClick,
  isDemo,
}: EstablishmentCardProps) {
  const [open, setOpen] = useState(true);

  let strAddress = "";
  if (establishment.address) {
    strAddress = strAddress + " " + establishment.address;
  }
  if (establishment.houseNumber) {
    strAddress = strAddress + ` Nª ${establishment.houseNumber}`;
  }
  if (establishment.complementaryAddress1) {
    strAddress = strAddress + `, ${establishment.complementaryAddress1}`;
  }
  if (establishment.complementaryAddress2) {
    strAddress = strAddress + `, ${establishment.complementaryAddress2}`;
  }

  return (
    <CCard className="mb-2">
      <CCardHeader
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <span>
          <strong>{establishment.code}</strong>
        </span>
        <span className="d-flex align-items-center gap-2">
          <strong>{""}</strong>
          <span
            className="rounded-circle bg-white d-flex justify-content-center align-items-center ml-1 border border-dark"
            style={{ width: "22px", height: "22px" }}
          >
            <i
              className={`fa fa-chevron-${open ? "up" : "down"}`}
              style={{ color: "black", fontSize: "12px" }}
            />
          </span>
        </span>
      </CCardHeader>
      <CCollapse show={open}>
        <CCardBody>
          <p>
            <strong>Denominación:</strong> {establishment.denomination}
          </p>
          <p>
            <strong>Dirección:</strong> {strAddress}
          </p>
          <p>
            <strong>Departamento:</strong> {establishment.departmentDescription}
          </p>
          <p>
            <strong>Distrito:</strong> {establishment.districtDescription}
          </p>
          <p>
            <strong>Ciudad:</strong> {establishment.cityDescription}
          </p>
          <p>
            <strong>Teléfono:</strong> {establishment.phoneNumber}
          </p>
          <p>
            <strong>Email:</strong> {establishment.email}
          </p>

          <div>
            <strong>Acciones disponibles:</strong>{" "}
            <EstablishmentCrudActions
              establishment={establishment}
              onUpdateClick={onUpdateClick}
              onDeleteClick={onDeleteClick}
              isDemo={isDemo}
            />
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
